module.exports = __webpack_public_path__ + "static/media/capa_backlight.050d670e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/capa_backlight.jpg
// module id = 321
// module chunks = 0